import { render, staticRenderFns } from "./EmployeeDetailsView.vue?vue&type=template&id=4cf5b742"
import script from "./EmployeeDetailsView.vue?vue&type=script&lang=js"
export * from "./EmployeeDetailsView.vue?vue&type=script&lang=js"
import style0 from "./EmployeeDetailsView.vue?vue&type=style&index=0&id=4cf5b742&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports